class MapSidebar {

    constructor(){
    }

}

export default MapSidebar;